export default __webpack_public_path__ + "static/media/termsBgDec1.b1c5966c.png";